import { Controller } from 'stimulus';

// Display-only on-the-fly unit converter for the materials show page.
// Each row holds a canonical value (and optional second value for ranges) plus
// a unit picker. On change, we ask /units/convert to reformat the canonical
// value into the picker's selected unit and rewrite the display targets.
//
// Storage stays in canonical units — this controller never mutates the source
// values, so flipping back and forth is precision-stable.
export default class extends Controller {
  static targets = ['display', 'display2', 'unitSelect'];

  connect() {
    this.canonicalValue = this.data.get('canonicalValue');
    this.canonicalValue2 = this.data.get('canonicalValue2');
    this.canonicalUnit = this.data.get('canonicalUnit');
  }

  convert() {
    const target = this.unitSelectTarget.value;
    if (!target || !this.canonicalUnit) return;

    if (target === this.canonicalUnit) {
      this.write(this.displayTarget, this.canonicalValue, target);
      if (this.hasDisplay2Target) this.write(this.display2Target, this.canonicalValue2, target);
      return;
    }

    this.fetchAndWrite(this.canonicalValue, target, this.displayTarget);
    if (this.hasDisplay2Target) {
      this.fetchAndWrite(this.canonicalValue2, target, this.display2Target);
    }
  }

  fetchAndWrite(value, to, el) {
    if (value == null || value === '') return;
    const params = new URLSearchParams({ value, from: this.canonicalUnit, to });

    fetch(`/units/convert?${params.toString()}`, {
      headers: { 'Accept': 'application/json' }
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('convert failed'))))
      .then((data) => this.write(el, data.value, to))
      .catch(() => {
        if (window.toastr) window.toastr.error('Unable to convert value between units.');
      });
  }

  write(el, value, unit) {
    if (value == null || value === '') {
      el.textContent = '';
      return;
    }
    el.textContent = `${value} (${unit})`;
  }
}
